module.exports = __webpack_public_path__ + "media/images/flags/32/Portugal-94016cd9c47415109a50a0f993ce666a.png";